import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { detect } from 'detect-browser';
import * as _ from 'lodash';
import { CookieService } from 'ngx-cookie-service';
import { Observable, Subscription } from 'rxjs';
import { map, pluck } from 'rxjs/operators';
import { ProjectService } from 'src/app/core/services/project.service';
import { AuthorizationService } from '../authorization/services/authorization.service';
import { Integration } from '../core/objects/Integration';
import { AboutPro, PaymentSlot } from '../core/objects/payment';
import { User } from '../core/objects/user';
import { IntegrationApiService } from '../core/services/integration-api.service';
import { NavigationService } from '../core/services/navigation.service';
import { NotificationsService } from '../core/services/notifications.service';
import { PaymentApiService } from '../core/services/payment-api.service';
import { ProjectApiService } from '../core/services/project-api.service';
import { UserApiService } from '../core/services/user-api.service';
import { UserService } from '../core/services/user.service';
import { TooMuchLoadsComponent } from '../modal/components/too-much-loads/too-much-loads.component';
import { ModalService } from '../modal/modal.service';
import { WorkingTableComponent } from '../working-table/working-table.component';
import { SharedProjectService } from './../core/services/shared-project.service';
import { Recommendation, SharedProject, UserNotificationType, WorkSpace } from './../core/types';
import { AboutMyAccountPopupComponent } from './about-my-account-popup/about-my-account-popup.component';
import { PaymentApiSuccessPopupComponent } from './payment-api-success-popup/payment-api-success-popup.component';
import { PaymentSuccessPopupComponent } from './payment-success-popup/payment-success-popup.component';
import { RolesEmailPopupComponent } from './roles-email-popup/roles-email-popup.component';
import { SlotsPopupComponent } from './slots-popup/slots-popup.component';
import { WelcomeApiPopupComponent } from './welcome-api-popup/welcome-api-popup.component';
import { WelcomeProPopupComponent } from './welcome-pro-popup/welcome-pro-popup.component';
// import { DataImportPopupComponent } from './data-import-popup/data-import-popup.component';
import { MessageService } from '../core/services/message.service';
import { UpdatesPopupComponent } from './updates-popup/updates-popup.component';
import { SubscriptionExpirePopupComponent } from './subscription-expire-popup/subscription-expire-popup.component';
import { PriceListUpdatePopupComponent } from './price-list-update-popup/price-list-update-popup.component';
// import { PaymentService } from '../core/services/payment.service';
import { ExternalUserPasswordPopupComponent } from './external-user-password-popup/external-user-password-popup.component';
import { Project } from '../core/objects/project';
import { VideoPopupComponent } from './video-popup/video-popup.component';
import { CustomerResearchPopupComponent } from './customer-research-popup/customer-research-popup.component';

// import { ContestPopupComponent } from './contest-popup/contest-popup.component';

@Component({
    selector: 'gl-container',
    templateUrl: './container.component.html',
    styleUrls: ['./container.component.scss'],
    standalone: false
})
export class ContainerComponent implements OnDestroy, AfterViewInit {
  public workingTable: WorkingTableComponent;
  @ViewChild(WorkingTableComponent, { static: false })
  public workingTableContent: WorkingTableComponent;
  public user: User;
  public workSpaces: WorkSpace[] = [];
  public currentWorkSpaceIndex = 0;
  public isBigQuantity = false;
  public projectName: string;
  public isSharedViewing: boolean;
  public acceptedTermsOfServiceAndPrivacyPolicy: string;
  public isMobile: boolean;
  public sharedProject: SharedProject;
  public openNoteClicked: boolean;
  public projectNote: string;
  public params: Record<string, string>;

  private popups = {
    welcomeProPopup: false,
    slotsPopup: false,
    prolongPopup: false,
    paymentSuccess: false,
    rolesEmail: false,
    tooMuchLoads: false,
    priceList: false,
    welcomeApiPopup: false,
    paymentApiSuccess: false,
    contestPopup: false,
    dataImport: false,
    priceListUpdate: false,
    customerResearchPopup: false,
    aboutMyAccountPopup: false,
    subscriptionExpirePopup: false,
    videoPopup: false,
  };
  private notifications = {
    afterLogin: false,
    newLoginMethod: false,
    hiddenAxis: false,
    automaticSubscription: false,
    proEnd: false,
    trial: false,
    contestPopup: false,
    dataImport: false,
    customerResearchPopup: false,
  };
  private previousUrl: string;
  private subscription: Subscription[] = [];
  private integrationApi: Integration;
  public isLeftMenuOpen = false;
  public isBottomMenuOpen = false;
  private aboutProSubscription: Subscription;

  constructor(
    private sharedProjectService: SharedProjectService,
    private projectService: ProjectService,
    private userService: UserService,
    private userApiService: UserApiService,
    private modalService: ModalService,
    private translate: TranslateService,
    private navigationService: NavigationService,
    public notificationsService: NotificationsService,
    public authorizationService: AuthorizationService,
    public projectApiService: ProjectApiService,
    public route: ActivatedRoute,
    public router: Router,
    private paymentApiService: PaymentApiService,
    private cookieService: CookieService,
    private changeDetectorRef: ChangeDetectorRef,
    private integrationApiService: IntegrationApiService,
    private messageService: MessageService,
  ) {
    //  this.userApiService.getNewsNotifications(this.translate.currentLang).subscribe();
    this.subscription.push(
      this.messageService.getMessages().subscribe((message) => {
        if (!message) return;
        switch (message.name) {
          case 'leftMenuClick':
            this.isLeftMenuOpen = !this.isLeftMenuOpen;
            break;
          case 'bottomMenuClick':
            this.isBottomMenuOpen = !this.isBottomMenuOpen;
            break;
        }
      }),
    );
    this.isLeftMenuOpen = this.projectService.isOpened;
    this.isBottomMenuOpen = this.projectService.isOpened;
    this.params = { ...this.route.snapshot.queryParams };
    const browser = detect();
    this.isMobile =
      browser.os === 'iOS' ||
      browser.os === 'Android OS' ||
      browser.os === 'BlackBerry OS' ||
      browser.os === 'Windows Mobile' ||
      browser.os === 'Amazon OS';
    this.subscription.push(
      this.sharedProjectService.isViewingShared.subscribe((isViewing: boolean) => {
        this.isSharedViewing = isViewing;
      }),
    );

    this.subscription.push(
      this.projectService.currentWorkSpaceIndex.pipe().subscribe((currentWorkSpace) => {
        this.currentWorkSpaceIndex = currentWorkSpace;
        this.notifications.hiddenAxis = false;
      }),
    );

    this.subscription.push(
      this.projectService.project.subscribe((project: Project): void => {
        this.workSpaces = project.workSpaces;
        if (!this.isSharedViewing) {
          this.getProjectName();
        }
        // if (
        //   !_.isEmpty(project.workSpaces) &&
        //   project.workSpaces[this.currentWorkSpaceIndex].cargoSpaces[0].frontAxi
        // ) {
        //   this.notifications.hiddenAxis = true;
        // }
      }),
    );
    this.subscription.push(
      this.userService.user.subscribe((user: User) => {
        this.user = user;
        if (!this.isSharedViewing) {
          this.getProjectName();
        }
        if (!this.isSharedViewing && !this.isMobile) {
          this.acceptedTermsOfServiceAndPrivacyPolicy = this.user.acceptedConsents?.find(
            (value) => value === 'termsOfServiceAndPrivacyPolicy',
          );
          this.openPriceListUpdatePopupIfNeeded();
        }
      }),
    );
    if (this.sharedProjectService) {
      this.subscription.push(
        this.sharedProjectService.sharedProject.subscribe(
          (sharedProject: SharedProject) => (this.sharedProject = sharedProject),
        ),
      );
    }
    this.previousUrl = this.navigationService.previousUrl;
    const quantity = this.projectService.getProjectQuantity();
    const isAfterSession = this.previousUrl.startsWith(`/${this.translate.currentLang}/session`);
    // this.openUpdatePopup();
    if (this.user.isPremium && this.cookieService.get('welcome') !== 'pro' && !this.isMobile) {
      this.popups.welcomeProPopup = true;
      this.openWelcomeProPopup();
    } else if (
      this.user.isPremium &&
      this.cookieService.get('welcome') === 'pro' &&
      !this.isSharedViewing &&
      !this.isMobile
    ) {
      this.subscription.push(
        this.paymentApiService.getAboutPro().subscribe((aboutPro: AboutPro) => {
          this.openSlotsPopup(aboutPro);
        }),
      );
    }

    if (this.user && Object.keys(this.user).length > 0) {
      this.integrationApiService.getIntegration().subscribe((result) => {
        this.integrationApi = result;
        if (
          this.integrationApi.clients.length > 1 &&
          this.cookieService.get('welcomeApi') !== 'true' &&
          !this.isMobile
        ) {
          this.popups.welcomeApiPopup = true;
          this.openWelcomeApiPopup();
        }
      });
    }

    if (!this.isMobile) {
      this.openPaymentSuccessPopup();
      this.openApiPaymentSuccessPopup();
    }

    if (
      ((!this.user.role ||
        !this.user.email ||
        !this.acceptedTermsOfServiceAndPrivacyPolicy ||
        !this.checkIsHaveEmailProvider()) &&
        this.user.token) ||
      (quantity > 10000 && !isAfterSession)
    ) {
      if (!this.isSharedViewing && !this.isMobile) {
        this.checkIsRolesEmail();
      } else if (!this.isMobile) {
        this.quantityCheck();
      }
    } else {
      this.notifications.afterLogin = true;
      this.addNotification();
    }

    if (!this.isSharedViewing && !this.isMobile) {
      this.checkInvoices();
      this.openPriceListUpdatePopupIfNeeded();
      this.checkTrial();
      this.checkProEnd();
      this.openAboutMyAccountPopup();
      // this.openContestPopup();
      // this.openDataImportPopup();
      this.openSubscriptionExpirePopup();
    }
    if (!this.isMobile && !this.isSharedViewing) {
      this.openVideoPopup();
    }
    // this.scheduleCustomerResearchPopup();
    this.deleteParams(isAfterSession);
  }

  private openVideoPopup(): void {
    const timesViewed = parseInt(localStorage.getItem('videoPopup'), 10) || 0;
    let showPopup = timesViewed < 2;
    if (showPopup) {
      localStorage.setItem('videoPopup', (timesViewed + 1).toString());
    }
    const isUserPremium = this.user.isPremium;
    const diffDays = Math.ceil(
      (Date.now() - new Date(this.user.registrationDate).getTime()) / (1000 * 60 * 60 * 24),
    );
    const isRegistrationDateOlderThan7Days = diffDays > 7;
    if (isUserPremium || isRegistrationDateOlderThan7Days) {
      showPopup = false;
    }
    if (showPopup) {
      this.popups.videoPopup = true;
      this.modalService.open(VideoPopupComponent).subscribe(() => {
        this.popups.videoPopup = false;
        this.addNotification();
      });
    }
  }

  // private scheduleCustomerResearchPopup(): void {
  //   if (
  //     !this.authorizationService.isLoggedIn() ||
  //     this.isSharedViewing ||
  //     localStorage.getItem('customerResearchPopupDismissed') === 'true'
  //   ) {
  //     return;
  //   }
  //   this.notifications.customerResearchPopup = true;
  //   this.addNotification();
  // }

  private openCustomerResearchPopup(): void {
    if (
      !this.authorizationService.isLoggedIn() ||
      this.isSharedViewing ||
      localStorage.getItem('customerResearchPopupDismissed') === 'true' ||
      this.popups.customerResearchPopup
    ) {
      return;
    }
    this.notifications.customerResearchPopup = false;
    this.popups.customerResearchPopup = true;
    this.modalService.open(CustomerResearchPopupComponent).subscribe(() => {
      this.popups.customerResearchPopup = false;
      this.addNotification();
    });
  }

  private hasBlockingPopup(): boolean {
    return Object.entries(this.popups).some(
      ([key, isOpen]) => key !== 'customerResearchPopup' && isOpen === true,
    );
  }

  public ngOnDestroy(): void {
    this.notificationsService.deleteAllNotification();
    this.subscription.forEach((sub: Subscription) => sub.unsubscribe());
    if (this.aboutProSubscription) {
      this.aboutProSubscription.unsubscribe();
    }
  }

  public deleteParams(isAfterSession: boolean) {
    const isSessionUrl = this.router.url.includes('/session');
    if (isAfterSession && !isSessionUrl) {
      delete this.params['id'];
    }

    delete this.params['code'];
    delete this.params['lp'];

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: this.params,
    });
  }

  public openNote() {
    this.openNoteClicked = !this.openNoteClicked;
  }

  public checkProEnd() {
    if (this.user.isPremium) {
      this.subscription.push(
        this.paymentApiService.getAboutPro().subscribe((aboutPro: AboutPro) => {
          const endPeriod = new Date(aboutPro.endPeriodDate);
          const dateNow = new Date();
          const diffTime = Math.abs(+endPeriod - +dateNow);
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          if (diffDays <= 2 && diffDays >= 0 && aboutPro.period === 'week_trial') {
            this.notifications.proEnd = true;
            this.addNotification();
          }
        }),
      );
    }
  }

  public ngAfterViewInit() {
    this.workingTable = this.workingTableContent;
    this.changeDetectorRef.detectChanges();
  }

  public checkTrial() {
    if (!this.user.isPremium && this.cookieService.get('disable_trial').includes('true')) {
      this.subscription.push(this.userApiService.disqualifyTrial().subscribe());
    } else if (this.user.isPremium) {
      this.cookieService.set('disable_trial', 'true', undefined, '/', null, false, 'Lax');
    } else if (
      !this.cookieService.get('disable_trial').includes('true') &&
      this.cookieService.get('disable_trial') !== 'wait'
    ) {
      this.subscription.push(
        this.paymentApiService.getPayment(this.user?.company?.country).subscribe((paymentData) => {
          const currencies = Object.getOwnPropertyNames(paymentData.actuallyPriceList);
          const periods = Object.getOwnPropertyNames(paymentData.actuallyPriceList[currencies[0]]);
          if (periods.find((el) => el === 'week_trial')) {
            this.notifications.trial = true;
            this.notifications.afterLogin = false;
            this.notifications.newLoginMethod = false;
            this.cookieService.set('disable_trial', 'wait', 86400000, '/', null, false, 'Lax');
            this.addNotification();
          }
        }),
      );
    }
  }

  public openPriceListUpdatePopupIfNeeded(): void {
    if (this.isSharedViewing || this.isMobile || this.popups.priceListUpdate) {
      return;
    }
    const user = this.userService.getState();
    if (!user?.notifications?.length) {
      return;
    }
    const notifications = user.notifications;
    const subscriptionNotification = notifications.find(
      (n) => n.type === 'price_list_update_subscription',
    );
    const generalNotification = notifications.find((n) => n.type === 'price_list_update_general');
    const target = subscriptionNotification ?? generalNotification;
    if (!target) {
      return;
    }
    this.popups.priceListUpdate = true;
    this.modalService
      .open(PriceListUpdatePopupComponent, {
        notificationId: target.id,
        notificationType: target.type as UserNotificationType,
      })
      .subscribe(() => {
        this.popups.priceListUpdate = false;
        this.addNotification();
      });
  }

  public checkInvoices() {
    if (this.user && this.user.notifications) {
      const subscriptionNotification = this.user.notifications.find(
        (notification) => notification.type === 'recurring_payment_charged',
      );
      if (subscriptionNotification) {
        const issueDate = new Date(subscriptionNotification.createdAt).getTime();
        if (+this.cookieService.get('issueDate') < issueDate) {
          this.notifications.automaticSubscription = true;
          this.cookieService.set(
            'issueDate',
            issueDate.toString(),
            undefined,
            '/',
            null,
            false,
            'Lax',
          );
          this.addNotification();
        }
      }
    }
  }

  private setLocalStorage(data: string, key: string): void {
    localStorage.setItem(key, data);
  }

  private getFromLocalStorage(key: string): string {
    return localStorage.getItem(key);
  }

  private getDate(): string {
    const currentDate: Date = new Date();
    const day: number = currentDate.getDate();
    const month: number = currentDate.getMonth() + 1;
    const year: number = currentDate.getFullYear();
    return `${year}.${month}.${day}`;
  }

  public openSubscriptionExpirePopup(): void {
    const currentDate: Date = new Date();
    let currentStringDate: string = this.getDate();
    if (!this.user.isPremium) return;
    this.aboutProSubscription = this.paymentApiService
      .getAboutPro()
      .subscribe((aboutPro: AboutPro): void => {
        const isPeriodExpireInSevenDays: boolean =
          aboutPro.endPeriodDate &&
          new Date(aboutPro.endPeriodDate).getTime() - currentDate.getTime() <=
            7 * 24 * 60 * 60 * 1000;
        const userEmail = aboutPro.slots[0].email;
        const localStorageDate: string = this.getFromLocalStorage(
          'subscriptionExpirePopup' + userEmail,
        );
        currentStringDate = currentStringDate + userEmail;
        if (
          Object.prototype.hasOwnProperty.call(aboutPro, 'isRenewable') &&
          aboutPro.isRenewable === true &&
          isPeriodExpireInSevenDays
        ) {
          if (currentStringDate !== localStorageDate) {
            this.setLocalStorage(currentStringDate, 'subscriptionExpirePopup' + userEmail);
          } else {
            return;
          }
          this.popups.subscriptionExpirePopup = true;
          this.modalService.open(SubscriptionExpirePopupComponent).subscribe(() => {
            this.popups.subscriptionExpirePopup = false;
            this.addNotification();
          });
          if (this.aboutProSubscription) {
            this.aboutProSubscription.unsubscribe();
          }
        }
      });
  }

  public openWelcomeProPopup() {
    this.modalService.open(WelcomeProPopupComponent).subscribe(() => {
      this.popups.welcomeProPopup = false;
      this.cookieService.set('welcome', 'pro', undefined, '/', null, false, 'Lax');
      this.subscription.push(
        this.paymentApiService
          .getAboutPro()
          .subscribe((aboutPro: AboutPro) => this.openSlotsPopup(aboutPro)),
      );
      this.addNotification();
    });
  }

  public openWelcomeApiPopup(): void {
    this.modalService.open(WelcomeApiPopupComponent).subscribe((): void => {
      this.popups.welcomeApiPopup = false;
      this.cookieService.set('welcomeApi', 'true', undefined, '/', null, false, 'Lax');
      this.addNotification();
    });
  }

  public openUpdatePopup(): void {
    const updateCount: string = this.getFromLocalStorage('updatePopupCount');
    const isEnd: boolean = updateCount === '3';
    if (isEnd) {
      return;
    }
    if (updateCount === null) {
      this.setLocalStorage('1', 'updatePopupCount');
    } else {
      const updateCountInt: number = parseInt(updateCount, 10);
      this.setLocalStorage((updateCountInt + 1).toString(), 'updatePopupCount');
    }
    this.modalService.open(UpdatesPopupComponent).subscribe();
  }

  public openSlotsPopup(aboutPro: AboutPro) {
    if (aboutPro && this.user.premiumRole === 'admin') {
      const filter = aboutPro.slots.filter((slot: PaymentSlot) => slot.email);
      if (aboutPro.slots.length > 1 && filter.length === 1) {
        this.popups.slotsPopup = true;
        this.modalService.open(SlotsPopupComponent).subscribe((result: boolean) => {
          this.popups.slotsPopup = false;
          if (result) {
            this.navigationService.navigateToSubscription();
          }
          //  this.openProlongPopup(aboutPro);
          this.addNotification();
        });
      } else {
        //  this.openProlongPopup(aboutPro);
      }
    } else {
      //   this.openProlongPopup(aboutPro);
    }
  }

  // public openProlongPopup(aboutPro: AboutPro) {
  // if (aboutPro.isRenewable && !this.cookieService.get('hideProlong').includes('true')) {
  //   this.popups.prolongPopup = true;
  //   this.modalService.open(ProlongPopupComponent).subscribe((result: boolean) => {
  //     this.popups.prolongPopup = false;
  //     if (result) {
  // this.popups.priceList = true;
  // this.subscription.push(
  //   this.paymentApiService.getPayment().subscribe(() =>
  //     this.modalService
  //       .open(SubscriptionPriceListComponent, {
  //         subscription: true,
  //         prolongAccess: true,
  //       })
  //       .subscribe(() => {
  //         this.popups.priceList = false;
  //         this.addNotification();
  //       }),
  //   ),
  // );
  //     }
  //     this.cookieService.set('hideProlong', 'true', 1, '/', null, false, 'Lax');
  //     this.addNotification();
  //   });
  // } else {
  //   this.addNotification();
  // }
  // }

  public openPaymentSuccessPopup() {
    this.subscription.push(
      this.route.queryParams.subscribe((queryData: { payment: 'true' }) => {
        if (!_.isEmpty(queryData) && queryData.payment === 'true') {
          if (!this.user.isPremium) {
            this.popups.paymentSuccess = true;
            this.modalService.open(PaymentSuccessPopupComponent).subscribe(() => {
              this.popups.paymentSuccess = false;
              delete this.params['payment'];
              this.router.navigate([], {
                relativeTo: this.route,
                queryParams: this.params,
              });
              this.addNotification();
            });
          } else {
            delete this.params['payment'];
            this.addNotification();
          }
        }
      }),
    );
  }

  public openApiPaymentSuccessPopup() {
    this.subscription.push(
      this.route.queryParams.subscribe((queryData: { paymentApi: 'true' }) => {
        if (!_.isEmpty(queryData) && queryData.paymentApi === 'true') {
          if (!this.user.isPremium) {
            this.popups.paymentApiSuccess = true;
            this.modalService.open(PaymentApiSuccessPopupComponent).subscribe(() => {
              this.popups.paymentApiSuccess = false;
              delete this.params['paymentApi'];
              this.router.navigate([], {
                relativeTo: this.route,
                queryParams: this.params,
              });
              this.addNotification();
            });
          } else {
            delete this.params['paymentApi'];
            this.addNotification();
          }
        }
      }),
    );
  }

  public openAboutMyAccountPopup() {
    if (
      this.user &&
      (!this.user.firstName || !this.user.lastName || !this.user.companyName) &&
      this.cookieService.get('aboutMyAccount') !== 'true'
    ) {
      this.popups.aboutMyAccountPopup = true;
      this.modalService.open(AboutMyAccountPopupComponent).subscribe((result: boolean) => {
        this.popups.aboutMyAccountPopup = false;
        this.popups.slotsPopup = false;
        if (result) {
          this.navigationService.navigateToProfile(true);
        }
        if (this.cookieService.get('aboutMyAccount') === '') {
          this.cookieService.set('aboutMyAccount', 'wait', undefined, '/', null, false, 'Lax');
        } else {
          this.cookieService.set('aboutMyAccount', 'true', undefined, '/', null, false, 'Lax');
        }
        this.addNotification();
      });
    }
  }

  public openDataImportPopup(): void {
    // if (this.previousUrl.startsWith(`/${this.translate.currentLang}/auth`)) {
    //   this.popups.dataImport = true;
    //   this.modalService.open(DataImportPopupComponent).subscribe(() => {
    //     this.popups.dataImport = false;
    //     this.notifications.dataImport = true;
    //     this.addNotification();
    //   });
    // }
  }

  // public openContestPopup() {
  //   if (this.previousUrl.startsWith(`/${this.translate.currentLang}/auth`)) {
  //     this.popups.contestPopup = true;
  //     this.modalService.open(ContestPopupComponent).subscribe(() => {
  //       this.popups.contestPopup = false;
  //       // this.notifications.contestPopup = true;
  //       // this.addNotification();
  //     });
  //   }
  // }

  public getProjectName(): void {
    this.projectName = this.projectApiService.currentProjectName;
    this.projectNote = this.projectApiService.currentProjectNote;
  }

  public isViewingSharedProject(): Observable<boolean> {
    return this.sharedProjectService.isViewingShared;
  }

  public isCargoSpaceDefined(length: number) {
    return this.workSpaces.length > length;
  }

  public closeNotification() {
    this.notificationsService.deleteNotification();
  }

  public isRecommendationsNotEmpty() {
    return this.projectService.project.pipe(
      pluck('recommendations'),
      map((recommendations: Recommendation[]) => recommendations.length > 0),
    );
  }

  private checkIsHaveEmailProvider() {
    return !!this.user.providers.find((el) => el === 'email');
  }

  private checkIsRolesEmail() {
    const quantity = this.projectService.getProjectQuantity();
    if (
      this.user &&
      (!this.user.role ||
        !this.user.email ||
        !this.acceptedTermsOfServiceAndPrivacyPolicy ||
        !this.checkIsHaveEmailProvider()) &&
      this.user.token
    ) {
      this.popups.rolesEmail = true;
      const token: string = this.route.snapshot.queryParamMap.get('aberg_user');
      const passwordChangePopup:
        | typeof ExternalUserPasswordPopupComponent
        | typeof RolesEmailPopupComponent = token
        ? ExternalUserPasswordPopupComponent
        : RolesEmailPopupComponent;
      this.modalService.open(passwordChangePopup).subscribe((whatChange: string) => {
        this.popups.rolesEmail = false;
        if (quantity <= 10000) {
          this.notifications.afterLogin = true;
        }
        if (whatChange === 'newPassword') {
          this.notifications.newLoginMethod = true;
        }
        this.addNotification();
      });
    }
  }

  private quantityCheck() {
    const quantity = this.projectService.getProjectQuantity();
    const isAfterSession = this.previousUrl.startsWith(`/${this.translate.currentLang}/session`);

    if (quantity > 10000 && !isAfterSession) {
      this.isBigQuantity = true;
      this.popups.tooMuchLoads = true;
      this.modalService
        .open(TooMuchLoadsComponent, { message: 'too_much_loads_project' })
        .subscribe((result) => {
          this.popups.tooMuchLoads = false;
          if (!result) {
            if (this.authorizationService.isLoggedIn()) {
              this.projectApiService.newProject().subscribe(() => {
                this.isBigQuantity = false;
                this.addNotification();
              });

              if (this.isSharedViewing) {
                this.sharedProjectService.endSharedView();
                this.navigationService.navigateToHomepage();
              }
            } else {
              this.sharedProjectService.endSharedView();
              this.navigationService.navigateToLogin();
            }
          } else {
            this.isBigQuantity = false;
            this.addNotification();
          }
        });
    }
  }

  private addNotification() {
    if (
      this.popups.paymentSuccess === false &&
      this.popups.prolongPopup === false &&
      this.popups.rolesEmail === false &&
      this.popups.slotsPopup === false &&
      this.popups.tooMuchLoads === false &&
      this.popups.welcomeProPopup === false &&
      this.popups.contestPopup === false &&
      this.popups.priceListUpdate === false &&
      this.popups.welcomeApiPopup === false &&
      this.popups.paymentApiSuccess === false &&
      this.popups.customerResearchPopup === false &&
      this.popups.aboutMyAccountPopup === false &&
      this.popups.subscriptionExpirePopup === false &&
      this.popups.videoPopup === false &&
      !this.isMobile
    ) {
      if (this.notifications.trial) {
        this.trialNotification();
      } else if (this.notifications.afterLogin) {
        this.checkAfterLoginNotification();
      }

      if (this.notifications.automaticSubscription) {
        this.automaticSubscriptionNotification();
      }

      if (this.notifications.proEnd) {
        this.proEndNotification();
      }

      if (this.notifications.newLoginMethod) {
        this.newLoginMethodNotification();
      }

      if (this.notifications.contestPopup) {
        this.contestPopupNotification();
      }

      if (this.notifications.dataImport) {
        this.dataImportNotification();
      }
    }

    if (this.notifications.customerResearchPopup && !this.hasBlockingPopup()) {
      this.openCustomerResearchPopup();
    }
  }

  private checkAfterLoginNotification() {
    const userName = this.user.firstName ? this.user.firstName : this.user.email;
    if (this.previousUrl.startsWith(`/${this.translate.currentLang}/auth`) && userName) {
      if (!this.user.isPremium && this.cookieService.get('welcome') === 'pro') {
        this.welcomeFreemiumNotification(userName);
        this.cookieService.set('welcome', 'free', undefined, '/', null, false, 'Lax');
      } else {
        this.haveNiceDayNotification(userName);
      }
    } else if (
      !this.user.isPremium &&
      this.cookieService.get('welcome') === 'pro' &&
      !this.isSharedViewing
    ) {
      this.welcomeFreemiumNotification(userName);
      this.cookieService.set('welcome', 'free', undefined, '/', null, false, 'Lax');
    }
  }

  private haveNiceDayNotification(userName: string) {
    this.notificationsService.addNotification(
      'good',
      `${this.translate.instant('have_nice_day') as string} ${userName} 🙂`,
      8000,
    );
    this.notifications.afterLogin = false;
  }

  private welcomeFreemiumNotification(userName: string) {
    this.notificationsService.addNotification(
      'good',
      `${this.translate.instant('good_day') as string} ${userName}, ${
        this.translate.instant('welcome_freemium') as string
      }`,
      8000,
    );
    this.notifications.afterLogin = false;
  }

  private newLoginMethodNotification() {
    this.notificationsService.addNotification(
      'good',
      `${this.translate.instant('new_login_method_notification_first') as string} ${
        this.user.email
      } ${this.translate.instant('new_login_method_notification_second') as string}`,
      8000,
    );
    this.notifications.newLoginMethod = false;
  }

  private automaticSubscriptionNotification() {
    this.notificationsService.addNotification(
      'warning',
      `${this.translate.instant('automatic_subscription_notification') as string}`,
    );
    this.notifications.newLoginMethod = false;
  }

  private proEndNotification() {
    this.notificationsService.addNotification(
      'warning',
      `${this.translate.instant('pro_end_notification') as string}`,
    );
    this.notifications.proEnd = false;
  }

  private trialNotification() {
    this.notificationsService.addNotification(
      'good',
      `${this.translate.instant('trial_notification') as string}`,
    );
    this.notifications.trial = false;
  }

  private dataImportNotification(): void {
    this.notificationsService.addNotification(
      'good',
      `${this.translate.instant('notification_data_import_new_goodloading') as string}`,
      8000,
    );

    this.notifications.dataImport = false;
  }

  private contestPopupNotification(): void {
    this.notificationsService.addNotification(
      'good',
      `${this.translate.instant('contest') as string}`,
      8000,
    );

    this.notifications.contestPopup = false;
  }
}
